import React, { useState } from "react";
import get from "lodash.get";
import { GeneralInfo, LinkInfo } from "components/General/InfoComponents";
import RoundYellowButton from "components/General/RoundYellowButton";
import mockEvent from "utils/mockEvent";
import { getEventPaymentType } from "utils/eventUtils";
import PufIcon from "components/General/PufIcons";
import { completeWeekday_MonthDayHrMnFormat } from "utils/time";
import { FaChevronDown } from "react-icons/fa";

const InfoContainer = (props: any) => {
  const event = get(props, "event", mockEvent);
  console.log({ event });
  const eventPaymentType = get(event, "payment_type.type");
  const paymentType: any = getEventPaymentType(eventPaymentType);
  const sponsors = get(event, "sponsors", []);
  const carClubName = get(event, "car_club.name");
  const driverUsername = get(event, "driver.username");
  const hostName = carClubName || driverUsername;
  const hostIcon = carClubName ? "Club-Icon" : "Garage-Icon";

  return (
    <div className="hContainer SFBold fontSize">
      <div style={{ width: "100%", textAlign: "start" }}>
        <div className="fontSizeBig">{event.name}</div>
        <div className="space" />
        {hostName ? (
          <>
            <GeneralInfo
              text={hostName}
              icon={
                <PufIcon
                  icon={hostIcon}
                  size={14}
                  set1={0}
                  className="smallPaddingRight"
                />
              }
            ></GeneralInfo>
            <div className="smallSpace" />
          </>
        ) : null}
        <LinkInfo
          uri={event.web_page}
          text={"Website"}
          icon={
            <PufIcon icon={"world"} size={14} className="smallPaddingRight" />
          }
        ></LinkInfo>
        <div className="smallSpace" />
        <Sponsors sponsors={sponsors} />
        <div className="smallSpace" />
        <div className="hContainer alignCenter yellow">
          <GeneralInfo text={ticketPriceLabel(event.tickets, event.cost)}></GeneralInfo>
          {paymentType ? (
            <>
            <div className="hSmallSpace" />
            <div style={{ flex: "0 0 auto" }}>
              <RoundYellowButton text={paymentType} />
            </div>
            </>
          ) : null}
        </div>
        <div className="smallSpace" />
        <div className="yellow">
          <GeneralInfo text={capacityLabel(event)}></GeneralInfo>
        </div>
        <div className="smallSpace" />
        <GeneralInfo
          text={
            "Starts: " + completeWeekday_MonthDayHrMnFormat(event.start_time)
          }
        ></GeneralInfo>
        <div className="smallSpace" />
        <GeneralInfo
          text={"Ends: " + completeWeekday_MonthDayHrMnFormat(event.end_time)}
        ></GeneralInfo>
        <div className="smallSpace" />
        <GeneralInfo
          text={event.address}
          icon={
            <PufIcon
              set1={0}
              icon="Direction-Icon"
              size={14}
              className="smallPaddingRight"
            />
          }
        ></GeneralInfo>
      </div>
    </div>
  );
};

const activeTickets = (tickets: any) =>
  (Array.isArray(tickets) ? tickets : []).filter(
    (ticket) => ticket && !ticket.deleted_at
  );

const formatMoney = (amount: any) => {
  const value = Number(amount);
  if (!Number.isFinite(value)) {
    return "0";
  }
  return Number.isInteger(value) ? String(value) : value.toFixed(2);
};

const ticketPriceLabel = (tickets: any, cost: any) => {
  const pricedTickets = activeTickets(tickets);
  if (pricedTickets.length > 0) {
    const prices = pricedTickets.map((ticket) => Number(ticket.price) || 0);
    const cheapest = Math.min(...prices);
    const mostExpensive = Math.max(...prices);
    if (mostExpensive === 0) {
      return "Ticket Price: Free";
    }
    if (cheapest === mostExpensive) {
      return "Ticket Price: $" + formatMoney(cheapest);
    }
    return (
      "Ticket Price: $" +
      formatMoney(cheapest) +
      " - $" +
      formatMoney(mostExpensive)
    );
  }
  return Number(cost)
    ? "Ticket Price: $" + formatMoney(cost)
    : "Ticket Price: Free";
};

const capacityLabel = (event: any) => {
  const tickets = activeTickets(event.tickets);
  const vehicleTicketHasNoLimit = tickets.some(
    (ticket) => !ticket.is_spectator_ticket && Number(ticket.spots) === 0
  );
  if (event.unlimited_spots || vehicleTicketHasNoLimit) {
    return "Attendees: " + (event.active_reservations_count ?? 0);
  }
  const total = Number(event.spots) || 0;
  const reserved = Number(event.active_reservations_count) || 0;
  const remaining = Math.max(total - reserved, 0);
  return "Spots available: " + remaining + "/" + total;
};

const Sponsors = (props: any) => {
  const sponsors = get(props, "sponsors", []);
  const [showSponsors, setShowSponsors] = useState(false);
  let mappedSponsors = null;
  let hasSponsors = false;
  if (sponsors && Array.isArray(sponsors) && sponsors.length > 0) {
    hasSponsors = true;
    mappedSponsors = sponsors.map((e, index) => {
      return <GeneralInfo key={index} text={e}></GeneralInfo>;
    });
  }
  if (hasSponsors) {
    return (
      <div>
        <div
          onClick={() => {
            setShowSponsors(!showSponsors);
          }}
        >
          <GeneralInfo
            text={"Sponsors"}
            icon={<FaChevronDown size={14} className="smallPaddingRight" />}
          ></GeneralInfo>
        </div>
        {showSponsors ? <div className="sponsors">{mappedSponsors}</div> : null}
      </div>
    );
  }
  return null;
};

export default InfoContainer;
